/**
 * GameRules — pure rule decisions shared by StageSim (client and server).
 *
 * Kept free of Phaser so the same rules can later be replayed server-side.
 */

/**
 * Whether a tap counts as correct.
 *
 * Normal play requires alternating W/C. Mechanics can prompt for a
 * specific key (pattern chain doubles like "C C", hazard "PRESS W"),
 * and a prompted key is correct even when it repeats the last key.
 *
 * @param {string|null} lastKey - Previous correct key, null on first tap
 * @param {string} key - 'W' or 'C'
 * @param {string[]} promptedKeys - Keys mechanics currently ask for
 * @returns {boolean}
 */
export function isCorrectTap(lastKey, key, promptedKeys = []) {
  if (!lastKey) return true;
  if (key !== lastKey) return true;
  return promptedKeys.includes(key);
}
